// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MkXW","colMin":"styles_colMin__2hUXh"};